import React from 'react';
import { Button } from '../../ui/button';
import { Banknote, CreditCard, RefreshCw } from 'lucide-react';

const PaymentModal = ({ show, selectedMesa, total, itemCount, sending, onPay, onClose }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" data-testid="payment-modal">
      <div className="bg-white rounded-2xl w-full max-w-sm shadow-2xl overflow-hidden">
        <div className="px-6 py-5 border-b">
          <h3 className="font-bold text-xl text-gray-900">Cobrar</h3>
          {selectedMesa && <p className="text-gray-500">Mesa {selectedMesa}</p>}
        </div>
        <div className="p-6 space-y-5">
          <div className="text-center py-3">
            <p className="text-sm text-gray-500 mb-1">Total</p>
            <p className="text-5xl font-bold text-green-600">{total.toFixed(2)}€</p>
            <p className="text-sm text-gray-400 mt-2">{itemCount} productos</p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Button onClick={() => onPay('efectivo')} disabled={sending}
              className="h-24 flex-col gap-3 bg-green-600 hover:bg-green-700 rounded-2xl" data-testid="pay-cash-btn">
              {sending ? <RefreshCw className="animate-spin" size={28} /> : <Banknote size={32} />}
              <span className="text-lg font-bold">Efectivo</span>
            </Button>
            <Button onClick={() => onPay('tarjeta')} disabled={sending}
              className="h-24 flex-col gap-3 bg-blue-600 hover:bg-blue-700 rounded-2xl" data-testid="pay-card-btn">
              {sending ? <RefreshCw className="animate-spin" size={28} /> : <CreditCard size={32} />}
              <span className="text-lg font-bold">Tarjeta</span>
            </Button>
          </div>
          <Button variant="outline" onClick={onClose} className="w-full h-12 text-base rounded-xl">
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
